module.exports = __webpack_public_path__ + "img/care-offer-4.3c95bfd6.jpg";